import {
  ADMIN_ADD_BATCH_REQUEST,
  ADMIN_ADD_BATCH_SUCCESS,
  ADMIN_ADD_BATCH_FAIL,
  ADMIN_GET_BATCH_REQUEST,
  ADMIN_GET_BATCH_SUCCESS,
  ADMIN_GET_BATCH_FAIL,
  ADMIN_UPDATE_BATCH_REQUEST,
  ADMIN_UPDATE_BATCH_SUCCESS,
  ADMIN_UPDATE_BATCH_FAIL,
  ADMIN_DELETE_BATCH_REQUEST,
  ADMIN_DELETE_BATCH_SUCCESS,
  ADMIN_DELETE_BATCH_FAIL,
  CLEAR_ERRORS
} from "../../constants/admin/batchConstants";

const initialState = {
  batches: [],
  loading: false,
  error: null,
};

export const batchReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_ADD_BATCH_REQUEST:
    case ADMIN_GET_BATCH_REQUEST:
    case ADMIN_UPDATE_BATCH_REQUEST:
    case ADMIN_DELETE_BATCH_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADMIN_ADD_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: [...state.batches, action.payload],
      };

    case ADMIN_GET_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: action.payload,
      };

    case ADMIN_UPDATE_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: state.batches.map((course) =>
          course._id === action.payload._id ? action.payload : course
        ),
      };

    case ADMIN_DELETE_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: state.batches.filter(
          (course) => course._id !== action.payload
        ),
      };

    case ADMIN_ADD_BATCH_FAIL:
    case ADMIN_GET_BATCH_FAIL:
    case ADMIN_UPDATE_BATCH_FAIL:
    case ADMIN_DELETE_BATCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

      case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
